import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';

export type ProgramEligibilitySearchType = 'ACCOUNT' | 'VIN';

export class ProgramEligibilityService {
    private client = new RequestClientInterfaceService();

    public search(
        searchType: ProgramEligibilitySearchType,
        searchValue: string,
    ) {
        const cognitoToken = sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = sessionStorage.getItem(PERMISSIONS_TOKEN_NAME);

        return this.client.sendRequest<unknown>({
            method: HttpMethod.post,
            url: `${DEALER_PORTAL_URL}/getProgramEligibility`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { searchType, searchValue, jwtToken: permissionsToken },
        });
    }

    public abort() {
        this.client.controller.abort();
    }
}
